import React from "react";
import MasterLayout from "../../../../masterLayout/MasterLayout";
import Breadcrumb from "../../../../components/Breadcrumb";
import MeetingSheetLayer from "../../../components/Admin/MeetingSheetLayer";

const MeetingSheet = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title='Add Category' />

        {/* BlankPageLayer */}
        <MeetingSheetLayer />
      </MasterLayout>
    </>
  );
};

export default MeetingSheet
